/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

import SupplierItemSelector from './SupplierItemSelector';
import SupplierItemFieldset from './SupplierItemFieldset';

function OrderItemsFieldset(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { arrayHelpers } = props;

  return (
    <FormikConsumer>
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <div>
          {values.items.slice().reverse().map((x, i) => (
            <Row key={`item_${values.items.length - (i + 1)}`}>
              <Col md="12" className="p-2 mt-3">
                <Row className="mb-3">
                  {x.supplier_items_id == null && (
                    <Col md="12">
                      <SupplierItemSelector
                        entity={x}
                        onChange={(item) => {
                          setFieldValue(`items[${values.items.length - (i + 1)}].supplier_items_id`, item.id);
                          setFieldValue(`items[${values.items.length - (i + 1)}].supplier_item`, item);
                          setFieldValue(`items[${values.items.length - (i + 1)}].price`, item.price);
                        }}
                        index={values.items.length - (i + 1)}
                      />
                      <button
                        onClick={() => {
                          arrayHelpers.remove(values.items.length - (i + 1));
                        }}
                        type="button"
                        className="close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </Col>
                  )}
                  {x.supplier_items_id != null && (
                    <Col md="12">
                      <SupplierItemFieldset
                        entityId={x.supplier_items_id}
                        index={values.items.length - (i + 1)}
                        remove={() => {
                          arrayHelpers.remove(values.items.length - (i + 1));
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          ))}
        </div>
      )}
    </FormikConsumer>
  );
}

OrderItemsFieldset.defaultProps = {
  t: (x) => (x),
};

OrderItemsFieldset.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(OrderItemsFieldset));
